export enum EUpwellingDepth {
  'DEPTH_0' = 0.5,
  'DEPTH_50' = 47,
  'DEPTH_100' = 92
}
